import Gravity from 'gravityglobal-parent/assets/js/global-functions';

const expandModule = () => {
  const modules = document.querySelectorAll('.gg-expandable-text-module');

  modules.forEach((module) => {
    const content = module.querySelector('.gg-expandable-text-module__content');
    const expandButton = module.querySelector('.gg-expandable-text-module__button');
    const heightModule = 200;
    const hiddenHeight = content.getAttribute('height') || heightModule;
    content.style.height = `${hiddenHeight}px`;

    const expand = () => {
      content.classList.add('active');
      expandButton.classList.add('hidden');
      const { scrollHeight } = content;
      content.style.height = `${scrollHeight}px`;
    };

    // Clear the saved height values after the transition
    content.addEventListener('transitionend', function removeTransition() {
      content.style.height = 'auto';
      content.removeEventListener('transitionend', removeTransition);
    });

    Gravity.clickEnterListener(expandButton, expand);
  });
};

Gravity.ready(expandModule);
